import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

/* eslint-disable react/no-array-index-key */

/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';
import { string, shape, arrayOf, bool } from 'prop-types';
import { Strip } from '../../atoms';
import { Container, Rules, Address, Line, Policy, Link } from './footer.styles';
/**
 *  This component is the webstore default `mobile` Footer
 */

function Footer(_ref) {
  let {
    footerData,
    strip,
    colors
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["footerData", "strip", "colors"]);

  const {
    rules = '',
    address = [],
    policy = {},
    links = []
  } = footerData;
  return /*#__PURE__*/React.createElement(Container, props, strip && /*#__PURE__*/React.createElement(Strip, null), /*#__PURE__*/React.createElement(Rules, {
    "data-testid": "rules-line",
    color: colors.rules
  }, rules), !!(policy != null && policy.label) && !!(policy != null && policy.link) && /*#__PURE__*/React.createElement(Policy, {
    "data-testid": "policy-line",
    target: "_blank",
    href: policy.link,
    rel: policy == null ? void 0 : policy.rel,
    color: colors.policy
  }, policy.label), !!(links != null && links.length) && links.map(link => /*#__PURE__*/React.createElement(Link, {
    key: link.label,
    "data-testid": "link-line",
    target: "_blank",
    href: link.url,
    rel: link == null ? void 0 : link.rel,
    color: colors.link
  }, link.label)), /*#__PURE__*/React.createElement(Address, null, address.map((item, idx) => /*#__PURE__*/React.createElement(Line, {
    key: idx,
    "data-testid": "address-line",
    color: colors.address
  }, item))));
}

Footer.defaultProps = {
  footerData: {},
  bg: 'background.primary',
  colors: {
    rules: 'text.white',
    policy: 'text.white',
    link: 'text.white',
    address: 'text.white'
  },
  strip: true
};
process.env.NODE_ENV !== "production" ? Footer.propTypes = {
  strip: bool,
  footerData: shape({
    rules: string,
    policy: shape({
      label: string,
      link: string
    }),
    links: arrayOf(shape({
      label: string,
      url: string
    })),
    address: arrayOf(string)
  }).isRequired,
  colors: shape({
    rules: string,
    policy: string,
    link: string,
    address: string
  })
} : void 0;
export default Footer;